import { Box, Typography } from "@mui/material";

const StatBox = ({ title, value, increase, icon, description }) => (
  <Box
    gridColumn="span 2"
    gridRow="span 1"
    sx={{
      background: "#fff",
      border: "1px solid #E2E8F0",
      borderRadius: "12px",
      p: "1.5rem",
      boxShadow: "0 1px 4px rgba(15,23,42,.06)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      transition: "all .22s",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 24px rgba(15,23,42,.1)",
      },
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: "#94A3B8",
          textTransform: "uppercase",
          letterSpacing: "1.5px",
          fontFamily: "IBM Plex Sans, sans-serif",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          background: "rgba(217,119,6,.1)",
          border: "1px solid rgba(217,119,6,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    </Box>
    <Typography
      sx={{
        fontSize: 30,
        fontWeight: 700,
        color: "#0F172A",
        fontFamily: "IBM Plex Sans, sans-serif",
        lineHeight: 1,
      }}
    >
      {value ?? "—"}
    </Typography>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1.5 }}>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "#D97706",
          fontFamily: "IBM Plex Sans, sans-serif",
        }}
      >
        {increase ?? ""}
      </Typography>
      <Typography
        sx={{
          fontSize: 11,
          color: "#94A3B8",
          fontFamily: "IBM Plex Sans, sans-serif",
        }}
      >
        {description}
      </Typography>
    </Box>
  </Box>
);

export default StatBox;
